interface HeaderMenuProps {
    className?: string
    color?: string
}
export const HeaderMenuWhite = ({ className, color }: HeaderMenuProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none" className={className}>
            <rect x="2" y="5.54688" width="24" height="2" rx="1" fill={color || 'white'} />
            <rect x="2" y="13.5469" width="18" height="2" rx="1" fill={color || 'white'} />
            <rect x="2" y="21.5469" width="24" height="2" rx="1" fill={color || 'white'} />
        </svg>
    )
}
